export default {
    NUMBERS: 'numbersView',
    DETAILS: 'detailsView',
    REGISTERED_DETAILS: 'registeredView',
    PROXY: 'proxyView'
};
